// Builds the price-aware "Get Started — $120/year" call-to-action label shared by
// the marketing pricing cards (pricing/BuySubscriptionButton) and the in-app
// redraw-denied paywall (payment/PricingCards), so the two surfaces can't drift
// apart. `price` is the already-formatted total (e.g. "$120"); `cadence` is
// 'month' or 'year'. Relies on the global i18n-js `t`, like the rest of the
// pricing components.
export const getStartedPriceLabel = (cadence, price) => {
  const key = cadence === 'month' ? 'sign_up.get_started_price_monthly' : 'sign_up.get_started_price_annual';
  return t(key).replace('%{price}', price);
};
